import React, { useEffect, useState } from "react";
import { api, fmtDateTime } from "../../lib/api";
import { BagLogo } from "../../components/Logo";
import { toast } from "sonner";
import { ArrowLeft, Mail, Phone, MapPin } from "lucide-react";

const STATUSES = ["NEW", "CONTACTED", "IN_DISCUSSION", "PARTNER", "REJECTED"];
const LABEL = { NEW: "Nova", CONTACTED: "Kontaktiran", IN_DISCUSSION: "U razgovoru", PARTNER: "Partner", REJECTED: "Odbijena" };
const TONE = {
  NEW: "bg-brand-red/10 text-brand-red", CONTACTED: "bg-brand-orange/10 text-brand-orange",
  IN_DISCUSSION: "bg-blue-100 text-blue-700", PARTNER: "bg-brand-green/10 text-brand-green",
  REJECTED: "bg-slate-100 text-slate-500",
};
const MAIL_TONE = { SENT: "text-brand-green", PARTIAL: "text-brand-orange", FAILED: "text-brand-red", PENDING: "text-slate-400" };

export default function B2BApplications() {
  const [rows, setRows] = useState(null);

  const load = () => api.get("/admin/b2b/applications").then(({ data }) => setRows(data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);

  const setStatus = async (a, status) => {
    try {
      const { data } = await api.patch(`/admin/b2b/applications/${a.id}`, { status });
      setRows((prev) => prev.map((x) => (x.id === a.id ? data : x)));
      toast.success("Status ažuriran");
    } catch { toast.error("Greška pri izmeni statusa"); }
  };

  return (
    <div className="min-h-screen bg-[#F9F9F7]" data-testid="b2b-admin-page">
      <header className="bg-brand-red text-white px-5 py-4 flex items-center gap-3">
        <a href="/admin" data-testid="b2b-admin-back" className="bg-white/15 rounded-full p-2"><ArrowLeft size={18} /></a>
        <BagLogo size={32} />
        <h1 className="font-display font-black text-lg">B2B prijave</h1>
        <span className="ml-auto text-sm font-bold">{rows?.length ?? ""}</span>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-5 space-y-3">
        {!rows && <p className="text-slate-400 text-sm">Učitavanje…</p>}
        {rows?.length === 0 && <p data-testid="b2b-admin-empty" className="bg-white rounded-2xl border p-4 text-sm text-slate-400">Još nema prijava.</p>}
        {rows?.map((a) => (
          <div key={a.id} data-testid={`b2b-app-${a.public_id}`} className="bg-white rounded-2xl border p-4">
            <div className="flex items-start justify-between gap-2">
              <div>
                <p className="font-display font-black">{a.restaurant_name}</p>
                <p className="text-xs text-slate-400">{a.public_id} · {fmtDateTime(a.created_at, "sr", true)}</p>
              </div>
              <span className={`text-[10px] font-black uppercase rounded-full px-2 py-1 ${TONE[a.status] || TONE.NEW}`}>
                {LABEL[a.status] || a.status}
              </span>
            </div>
            <div className="mt-2 space-y-1 text-sm text-slate-600">
              <p className="flex items-center gap-1.5"><MapPin size={13} className="text-slate-400" />{a.city_name || a.city_id}</p>
              <p className="flex items-center gap-1.5"><Mail size={13} className="text-slate-400" />
                <a href={`mailto:${a.email}`} className="font-semibold text-brand-red">{a.email}</a></p>
              <p className="flex items-center gap-1.5"><Phone size={13} className="text-slate-400" />
                <a href={`tel:${a.phone}`} className="font-semibold">{a.phone}</a>
                {a.contact_name ? <span className="text-slate-400">· {a.contact_name}</span> : null}</p>
              {a.message && <p className="bg-[#FAFAF8] rounded-xl p-2.5 text-sm">{a.message}</p>}
            </div>
            <div className="mt-3 flex flex-wrap items-center gap-1.5">
              {STATUSES.map((s) => (
                <button key={s} data-testid={`b2b-status-${a.public_id}-${s}`} onClick={() => setStatus(a, s)}
                  className={`rounded-lg px-2.5 py-1.5 text-xs font-black border-2 ${a.status === s ? "border-brand-red bg-brand-red text-white" : "border-slate-200 text-slate-500"}`}>
                  {LABEL[s]}
                </button>
              ))}
              <span className={`ml-auto text-[11px] font-black uppercase ${MAIL_TONE[a.email_delivery_status] || ""}`}>
                Email: {a.email_delivery_status || "—"}
              </span>
            </div>
          </div>
        ))}
      </main>
    </div>
  );
}
